import { isProd } from '@/utils/getApiDomain';

import { AuthGrid } from '../auth/authGrid';
import { AuthIDEnum } from '../auth/authID';

const Docs = () => (
    <AuthGrid id={AuthIDEnum.BOT}>
      <iframe style={{ width: '100vw', height: '100vh' }}
        src={isProd ? 'https://dreamai.fun/docs/doc?id=6c47454a57db3f91' : 'https://test.dreamai.fun/docs/doc?id=6c47454a57db3f91'} />
    </AuthGrid>
);

export default Docs;
